import { React, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { SiBinance } from 'react-icons/si'
import { MdAdd } from 'react-icons/md'
import { ImCross } from "react-icons/im";
import FastMenu from './FastMenu'
import SelectToken from './SelectToken'




export default function FindLiquidity() {

    const history = useHistory();

    const [Alert, setAlert] = useState(1)

    const [state, setstate] = useState(0)

    const [pop, setPop] = useState(0)

    return (
        <div className="container pt-lg-5 pt-3">
                   {pop == 1 && <SelectToken passState={setPop} />}

            {Alert == 1 &&
                <div className="col-lg-6 mx-auto mb-4" >
                    <div className="card g-card px-lg-3 py-3">
                        <div className="card-body">
                            <div className="d-flex justify-content-end" style={{ marginTop: "-10px", marginRight: "-10px" }}>
                                <ImCross className="cross-icon fs-6 pointer" onClick={() => setAlert(0)} />
                            </div>
                            <div className="d-flex ">
                                <span>
                                    Tip: <span className="text-faded">By adding liquidity you'll earn interest from farms stake pool where you look your liquidty provider tokens (LP) </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <div className="d-flex justify-content-center align-items-center">
                <div className="ws-tabs">
                    <Link to='/swap' >Swap</Link>
                    <Link to='/liquidity' className="active">Liquidity</Link>
                    <Link to='/liquidity'>Bridge</Link>
                </div>
            </div>
            <div className="row mx-0 mt-4 justify-content-center">
                <div className="col-lg-6 px-0">
                    <div className="card g-card px-lg-3 py-3">
                        <div className="ws-tabs bg-transparent d-flex justify-content-center mt-3">
                            <Link to='/add-liquidity'>Add</Link>
                            <Link to='/find-liquidity' >Remove</Link>
                        </div>
                        <div className="card-body">

                            <div className="d-flex justify-content-between  ">
                                <p className="mb-0">Liquidity</p>
                                <div className="d-flex align-items-center">
                                    <span className="pe-2">Sounds</span>
                                    <label className="switch">
                                        <input type="checkbox" />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                          <FastMenu/>
                            <div className="d-flex flex-column">
                                <div className={state == 1 ? "ws-exchange-card  mt-3 order-2" : "ws-exchange-card active mt-3 order-0"}>
                                    <span className="text-faded text-small text-uppercase pb-2">From</span>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center">
                                            <div className="coin-icon" >
                                                <SiBinance />
                                            </div>
                                            {/* <Dropdown>
                                                <Dropdown.Toggle id="dropdown-basic">
                                                    BNB
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown> */}

                                            <span className='fs-6 ps-2' onClick={()=>{setPop(1); window.scrollTo(0,0)}}>BNB</span>

                                        </div>
                                        <div>0.982378</div>
                                    </div>

                                </div>
                                <div className="exchange-btn order-1">
                                    <div>
                                        <span >
                                            <MdAdd />
                                        </span>
                                    </div>
                                </div>
                                <div className={state == 1 ? "ws-exchange-card active mt-3 order-0" : "ws-exchange-card mt-2 order-2"}>
                                    <span className="text-faded text-small text-uppercase pb-2">To</span>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center">
                                            <div className="coin-icon">
                                                <SiBinance />
                                            </div>
                                            {/* <Dropdown>
                                                <Dropdown.Toggle id="dropdown-basic">
                                                    Select
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown> */}

                                            <span className='fs-6 ps-2' onClick={()=>{setPop(1); window.scrollTo(0,0)}}>Select</span>

                                        </div>
                                        <div>0.0</div>
                                    </div>
                                </div>
                            </div>


                            <div className="ws-exchange-card  mt-3 active just-box p-3"  >
                                <span className="text-faded text-small text-uppercase py-2">select your liquidity</span>
                                <div className="row">
                                    <div className="col-6 d-flex flex-column">
                                        <span className="fs-5 text-uppercase pointer" onClick={() => history.push('/remove-liquidity')}> bnb/busd </span>
                                    </div>
                                    <div className="col-6 d-flex flex-column">
                                        <span className="fs-5 text-uppercase pointer " onClick={() => history.push('/remove-liquidity')}> 0.00007</span>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between py-4 border-bottom">
                                <div className="d-flex align-items-start flex-column">
                                    <span className=" text-small ">Slippage tolerance</span>
                                </div>
                                <div className="d-flex align-items-end flex-column">
                                    <div className="d-flex align-items-center">
                                    <input className="harvest text-uppercase text-faded-3 ms-2" defaultValue='0.1' style={{ width: "50px" }} />
                                        <input className="harvest text-uppercase text-faded-3 ms-2" defaultValue='0.6' style={{ width: "50px" }} />
                                        <input className="harvest text-uppercase text-faded-3 ms-2" defaultValue='1' style={{ width: "50px" }} />
                                        <input className="harvest text-uppercase text-faded-3 ms-2 me-2" defaultValue='0.00' style={{ width: "60px" }} />
                                        <span className=" text-small ">%</span>
                                    </div>
                                </div>

                            </div>
                            <span className=" text-small text-uppercase text-faded pt-3">Recent transaction</span>
                            <div className="d-flex justify-content-center pt-4">
                                <button className="g-btn">Connect wallet</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
